<template>  
    <div>
    	<div v-if="allAccountList.totalRecords == 0">
			<div class="mainTitle  text-center my-3">
				<h3>{{$t('VpsSub_noTradingAccFound')}}</h3>
			</div>
			<no-trading-account :demo_live_both="''" :totalRecords = "allAccountList.totalRecords"></no-trading-account>
		</div>
		<div v-else-if="parseInt(allAccountList.totalRecords) == 1">
			<div class="CustomBlockWidth " >
				<div class=" row justify-content-center">
					<div class="middleBox">
						<div class="whiteBG p-4"> 
							<div class="card ">
							  <div class="card-body text-center">
								<img src="../../../../../static/fxView/images/lost.svg" alt="no account found" class="mb-4" width="200">  
								<p class="mb-3">{{$t('VpsSub_1_Record')}}</p>
								<router-link to="/create-live-account" class="prism_btn btn_sm lift">{{$t('VpsSub_liveAcc')}}</router-link>
								<router-link to="/wallet" class="prism_btn btn_sm lift">{{$t('VpsSub_Wallet')}}</router-link>
							  </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <div  v-else-if="allAccountList.totalRecords > 1">
        	<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleWithdrawal)">
	            <app-twofa  :call_from="request_page"></app-twofa>
	        </div>
			<div v-else>
				<div class="mainTitle text-center my-3"> 
	                <h2 class="mb-3"> {{$t('VpsSub_ChangeTradAcc')}}</h2>
	                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
	            </div>
	            <!--loader - message--->
	            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
	            <div class="row no-gutters justify-content-center">
	            	<div class="whiteBG p-4 mb-3 middleBox " > 
							<div class="justify-content-center">
								<!--------------request page---------------------------------->
								<div class="partcipate-fund" v-if="transaction_id == '' && !congModuleWithdrawal">
									<div class="form-group field-wrapper" >
										<account-id></account-id>
									</div>
									<div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
										<router-link to="/tools/VPS" class="d-flex align-items-center"><feather class="mr-1" type="chevron-left"></feather> {{$t('VpsSub_back_subLis')}}</router-link>
										<button class="prism_btn btn_sm" v-on:click.prevent="submitRequestOtp()" > {{$t('VpsSub_Submit')}}</button>
									</div>	
									<!-- <div class="submitButton w-100 mt-2 text-center" >
										<button class="prism_btn btn_sm" @click.prevent="submitRequestOtp()" > Submit</button>
									</div> -->
								</div>

								<!------------------------------------------------------------->
								<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleWithdrawal">
									<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
										<p class="mb-3 text-center">{{$t('rb_googleAuth1')}} <strong>{{$t('rb_googleAuth2')}}</strong> {{$t('rb_googleAuth3')}}. </p>
										<div class="form-group field-wrapper">
											<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedCheckOtp && errors.has('otp') }" ref="otpInput">
											<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
										</div> 
										<div class="form-group text-center field-wrapper">
											<button class="prism_btn btn_sm " v-on:click.prevent="submitCheckOtp()">{{$t('rb_validate')}} </button>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
											<div class="desc text-center">
												<p>{{$t('rb_googleAuth4')}} <a v-on:click.prevent="resendLink()" href="#"><strong>{{$t('rb_googleAuth5')}}</strong></a></p>
											</div>
										</div>
										<div class="clearfix"></div>
									</div>

									<div class="middleBox1"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
										<div class="congratulations">
											<div class="logo_congrats">
												<img src="../../../../../static/fxView/images/withdraw.svg" alt="Icon">
											</div>
											<div class="subtitle">
												<p class="mb-3">{{$t('verf_dear')}} <strong class="green">{{get_user.username}} !</strong>
													{{$t('VpsSub_withdrawalAuthMessage')}} <strong>{{get_user.email}} . </strong> 
												</p>
												<a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{$t('rb_googleAuth7')}}</strong></a>
											</div>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
											<div class="ico mr-3">
												<img src="../../../../../static/fxView/images/google_auth.png" alt="2fa">
											</div>
											<div class="desc w-75">
												<h5 class="mb-2"><strong>{{$t('rb_googleAuth8')}}</strong></h5>
													<p>{{$t('rb_googleAuth9')}} <a v-on:click.prevent="authComponent = true" href="#"><strong>{{$t('rb_googleAuth10')}}</strong></a></p>
											</div>
										</div>
									</div>
								</div>
								<!------------congo msz final for withdrawal page------------------------->
								<div class="stepForm" v-if="congModuleWithdrawal">
									<div class="congratulations">
										<div class="logo_congrats">
											<img src="../../../../../static/fxView/images/check.svg" alt="Icon">
										</div>
										<div class="subtitle">
											<h3>{{$t('rb_congo')}} <span class="green">{{get_user.username}}</span></h3>
											<p>{{$t('VpsSub_received_request')}}</p>
											
										</div>
										<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
											 <router-link to="/tools/VPS" class="prism_btn btn_sm">{{$t('VpsSub_back_subLis')}}</router-link>
										</div>
									</div> 
								</div> 
							</div> 
						</div> 	

	            </div>
				
				
			</div>
        </div>
		
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('rb_plzWaitWhileProc')}}</h4>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
	import FlipCountdown from 'vue2-flip-countdown'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import twoFa from '../../users/2FA' 
	import moment from 'moment'
    export default {
        name: 'subscription-chnage-account',
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : this.$options.name,
            	//============message and loader ===========
                response_msg : '',
                msg_type : '',
				
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
               

                submitted : false,
                authComponent : false,
                //-----select account----
				selectAccount : false,
                account_id : '',
                act_account_id : '',
				demo_live : '',
				platform : '',
				
				//=====================

                otp : '',
                transaction_id : '',
                submittedCheckOtp : false,
                congModuleWithdrawal : false,
				
                request_page : 'subscription' 
            }
        },
        components: {
            appTwofa: twoFa 
        },
        methods:{ 
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runSubscriptionResendEmailLink(input_json)
            },
            submitRequestOtp(){
                const _that = this
                _that.submitted = true; 
                _that.$validator.validate().then(valid => {
                    if (valid){
						let input_json={
							'globalParams' :{
								'to_account_id' : _that.account_id ,
								'subscription_id':  this.$route.query.id,
								"operation" : "SUBSCRIPTION_ACCOUNT_CHANGE"
							},
							'localParams' :{ "parameter" : _that }
						}
						_that._runSubscriptionRequestOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            submitCheckOtp(){
                const _that = this
                _that.submittedCheckOtp = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runSubscriptionCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tools/pages/sub_change_account.vue